module.exports = __webpack_public_path__ + "fonts/RobotoMono-Regular.f9af7228.woff2";